import React, { useEffect, useState } from 'react';
import { changeLanguage, i18n } from "../../translate/i18n";
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import api from "../../services/api";

const LanguageControl = () => {
    const [selectedLanguage, setSelectedLanguage] = useState('en');

    const handleLanguageChange = async (lang) => {
        const allowedLangs = ["pt", "en", "es"];
        if (!allowedLangs.includes(lang)) {
          console.warn("Idioma inválido:", lang);
          return;
        }
      
        i18n.changeLanguage(lang);
      
        const token = localStorage.getItem("token");
        if (!token) return;
      
        try {
          await api.post(`/users/set-language/${lang}`);
        } catch (err) {
          console.warn("Erro ao atualizar idioma no servidor:", err);
        }
      };
      

    useEffect(() => {
        const saveLanguage = localStorage.getItem('i18nextLng');
        setSelectedLanguage(saveLanguage);
    }, []);

    return (
        <div>
            <label htmlFor="language-select">{i18n.t("selectLanguage")}</label>
            <RadioGroup
                aria-label="language"
                name="language-radio-group"
                value={selectedLanguage}
                onChange={(e) => {
                    const lang = e.target.value;
                    setSelectedLanguage(lang);
                    handleLanguageChange(lang);
                }}
                row
                >
                <FormControlLabel value="pt" control={<Radio />} label="Português (BR)" />
                <FormControlLabel value="en" control={<Radio />} label="English" />
                <FormControlLabel value="es" control={<Radio />} label="Español" />
            </RadioGroup>
        </div>
    );
};

export default LanguageControl;